const axios = require('axios');
const SERVER_URL = process.env.REACT_APP_SERVER_URL;

const SecurityPlanService = {
    get: async () => {
        try {
            const response = await axios.get(`${SERVER_URL}/api/securityPlan`, { withCredentials: true });
            return response;
        } catch(err) {
            return err.response;
        }
    },
    post: async (data) => {
        try {
            const response = await axios.post(`${SERVER_URL}/api/securityPlan`, data, { withCredentials: true });
            return response;
        } catch(err) {
            return err.response;
        }
    },
    delete: async (data) => {
        try {
            const response = await axios.delete(`${SERVER_URL}/api/securityPlan`, { data, withCredentials: true });
            return response;
        } catch(err) {
            return err.response;
        }
    }
}

export default SecurityPlanService;